import * as React from 'react';
import * as SeparatorPrimitive from '@radix-ui/react-separator';
import { cn } from '@/common-utils/libraries/tailwind/utils';
import PropTypes from 'prop-types';


const Separator = React.forwardRef(
    (
        { className, style = undefined, orientation = 'horizontal', decorative = true, ...props },
        ref
    ) => (
        <SeparatorPrimitive.Root
            ref={ref}
            decorative={decorative}
            orientation={orientation}
            style={style}
            className={cn(
                'shrink-0 bg-stone-300',
                orientation === 'horizontal' ? 'h-[1px] w-full' : 'h-full w-[1px]',
                className
            )}
            {...props}
        />
    )
);

Separator.displayName = SeparatorPrimitive.Root.displayName;

Separator.propTypes = {
    className: PropTypes.string,
    style: PropTypes.object,
    orientation: PropTypes.oneOf(['horizontal', 'vertical']),
    decorative: PropTypes.bool
};

export { Separator };